module.exports = __webpack_public_path__ + "static/media/logo-ict.f08b5b3b.png";